import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './user'
import mark from './mark'
import note from './note'
import other from './other'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    mark,
    note,
    other
  },
  getters
})
